/**
 * Az admin API példány. A mód (mock vagy http) a VITE_API_MODE-ból jön; a megvalósítás dinamikusan
 * töltődik, így az éles build nem tartalmazza a mock adatbázist és a minta adatokat. http módban a
 * VITE_API_BASE_URL kötelező: csendes visszaesés a mockra nincs, az éles felület sosem fut demó adattal.
 */
import type { AdminApi } from './types'

let instance: AdminApi | null = null

export async function initAdminApi(): Promise<AdminApi> {
  if (instance) return instance
  const mode = import.meta.env.VITE_API_MODE ?? 'mock'
  if (mode === 'http') {
    const base = import.meta.env.VITE_API_BASE_URL
    if (!base) throw new Error('VITE_API_MODE=http esetén a VITE_API_BASE_URL megadása kötelező')
    const { HttpAdminApi } = await import('./http/httpAdminApi')
    instance = new HttpAdminApi(base)
  } else {
    const { MockAdminApi } = await import('./mock/mockAdminApi')
    const latency = import.meta.env.VITE_MOCK_LATENCY_MS
    instance = new MockAdminApi({ latencyMs: latency ? Number(latency) : null })
  }
  return instance
}

/** Az inicializált API (az indításkor lefutott initAdminApi után). */
export function api(): AdminApi {
  if (!instance) throw new Error('Az admin API még nincs inicializálva')
  return instance
}
